import { siteConfig } from "@acme/config";
import { Link } from "@tanstack/react-router";

/**
 * The wordmark, sized by `.logo` in chrome.css so the header and footer can
 * scale it per breakpoint without prop drilling.
 *
 * Rendered as `<img>` rather than inline SVG on purpose: the header and the
 * footer both mount one, and the mark is a static file the browser caches once
 * and paints twice — inlining would ship its paths in every document instead.
 * Plain `<img>` over `@unpic/react` because this is a local vector, not a CDN
 * raster.
 *
 * `logoDark` is the dark-ink cut, which is the one that belongs on the paper
 * ground. The site ships a single light rendition, so there is no second cut to
 * swap in.
 */
export function SiteLogo({ className }: Readonly<{ className?: string }>) {
  return (
    <Link aria-label={`${siteConfig.name} home`} className="logo" to="/">
      <img
        alt={siteConfig.name}
        className={className}
        height={37}
        src={siteConfig.logoDark}
        width={139}
      />
    </Link>
  );
}
